export const LOAD_REQUESTED = "SECTION_TITLE/LOAD_REQUESTED";
export const LOAD_SUCCESS = "SECTION_TITLE/LOAD_SUCCESS";
export const LOAD_FAIL = "SECTION_TITLE/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadSectionTitle = data => ({ type: LOAD_REQUESTED, data });
export const successLoadSectionTitle = data => ({ type: LOAD_SUCCESS, data });
export const failLoadSectionTitle = data => ({ type: LOAD_FAIL, data });
